/**
 * useDocumentTitle — keeps `document.title` in sync with a given string.
 *
 * Restores the previous title on unmount so nested pages don't leak titles.
 *
 * @example
 * useDocumentTitle('Cases — Breadify');
 * useDocumentTitle(companyName ? `${companyName} — Breadify` : 'Breadify');
 */
import { useEffect, useRef } from 'react';

export function useDocumentTitle(title: string) {
  const previousTitle = useRef(document.title);

  useEffect(() => {
    document.title = title;
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      document.title = previousTitle.current;
    };
  }, [title]);
}
